import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@monorepo/nova-ui';

export const SupportedSymbolsEmpty: FC = () => {
  const { t } = useTranslation(['keyMetrics']);

  return (
    <Stack alignItems="center" justifyContent="center" minHeight={200} gap={2}>
      <Typography variant="h6" align="center">
        {t('keyMetrics:supportedSymbols.emptyState')}
      </Typography>
    </Stack>
  );
};
